<template>
	<div class="mb-3 p-3 rounded-6 bg-history cursor-pointer" @click="selectDetail">
    <div class="row slim-grid-row">
      <div class="col-1">
        <div class="rounded-100 text-center w-30px mt-1 bg-green-light">
          <i class="text-green m-auto position-relative":class="icon" style="top: 2px;left: 1px"></i>
        </div>
      </div>
      <div class="col-7">
        <div class="ml-3">
          <p class="mb-0 body-2-2 font-bold text-16">{{data.module.name}}</p>
          <p class="mb-0 body-2-2 font-regular text-12">{{formatDate(data.created_at)}}</p>
        </div>
      </div>
      <div class="col-4 text-right">
        <p class="mb-0 body-2-2 font-bold text-14" :class="status.class_name">{{status.text}}</p>
      </div>
    </div>
    <div class="mt-2 pt-1">
      <div class="row slim-grid-row">
      	<div class="col-4" v-if="data.module.slug=='laundry'">
          <p class="mb-0 body-3">Invoice:</p>
          <p class="mb-0 body-3-1 text-truncate">{{data.invoice}}</p>
        </div>
      	<div class="col-8" v-if="data.module.slug=='laundry'">
          <p class="mb-0 body-3">Order:</p>
          <p class="mb-0 body-3-1 text-truncate-2">{{order_list}}</p>
        </div>
      	<template v-else>
      		<div :class="{
      			'col-4': type == 'history',
      			'col-6':type=='chat'
      		}">
	          <p class="mb-0 body-3">{{$t('hotel.concierge.invoice')}}:</p>
	          <p class="mb-0 body-3-1 text-truncate">{{data.invoice}}</p>
	        </div>
	        <div :class="{
	        	'col-4': type == 'history',
	        	'col-6': type == 'chat' && data.module.slug == 'maintenance-request'
	        }" v-if="type == 'history' || (type == 'chat' && data.module.slug == 'maintenance-request')">
	          <p class="mb-0 body-3">{{$t('hotel.concierge.order')}}:</p>
	          <p class="mb-0 body-3-1 text-truncate">{{data.module.slug == 'maintenance-request' ? data.tx_detail_list.name : order_list}}</p>
	        </div>
	        <div :class="{
	        	'col-4': type == 'history', 
	        	'col-6':type=='chat'
	        }" v-if="data.module.slug != 'maintenance-request'">
	          <p class="mb-0 body-3">{{$t('general.price')}}:</p>
	          <p class="mb-0 body-2-2 text-14 font-semibold text-truncate">{{formatCurrency(data.total_payment)}}</p>
	        </div>
      	</template>
      </div>
    </div>
  </div>
</template>
<script>
	import moment from 'moment'
	import {formatCurrency} from '@/utils/index.js'
	export default{
		props: {
			data:{
				type: Object,
				default: () => {}
			},
			type: {
				type: String,
				default: 'history'
			}
		},
		computed:{
			icon(){
				let class_name = 'iconsmind-Coffee'
				if(this.data.module.slug == 'room-dining'){
					class_name = 'iconsmind-Coffee'
				}else if(this.data.module.slug == 'extra-amenities'){
					class_name = 'iconsmind-Cap'
				}else if(this.data.module.slug == 'spa'){
					class_name = 'iconsmind-Sun'
				}else if(this.data.module.slug == 'laundry'){
					class_name = 'iconsmind-T-Shirt'
				}else if(this.data.module.slug == 'maintenance-request'){
					class_name = 'iconsmind-Wrench'
				}
				return class_name
			},
			status(){
				let data = {
					class_name : 'text-orange',
					text : this.$t('hotel.concierge.waiting')
				}
				if(this.data.status == 'PENDING'||this.data.service_status === 'TODO'){
          data.class_name = 'text-orange'
          data.text = this.$t('hotel.concierge.waiting')
        }else if(this.data.status == 'ONPROGRESS'||this.data.service_status === 'DOING'){
          data.class_name = 'text-info'
          data.text = this.$t('hotel.concierge.on-progress')
        }else if(this.data.status == 'COMPLETE'||this.data.service_status === 'DONE'){
          data.class_name = 'text-green'
          data.text =  this.$t('hotel.concierge.complete')
        }else if(this.data.status == 'CANCELLED'||this.data.service_status === 'CANCELLED'){
          data.class_name = 'text-danger'
          data.text = this.$t('hotel.concierge.cancelled')
        }else{
          data.class_name = 'text-warning'
          data.text = this.data.status
        }
				return data
			},
			order_list(){
				if(this.data.module.slug != 'maintenance-request'){
					let data = ''
					let laundry_type = this.data.module.slug == 'laundry' && this.data.module.type == 'pcs' ? 'PCS' : 'KILO'
					if(this.data.module.slug == 'laundry'){
						data = laundry_type+" "
					}
					for(let i = 0 ; i < this.data.tx_detail_list.length;i++){
						let product = this.data.tx_detail_list[i]
						let key = this.data.module.slug == 'laundry' && this.data.module.type == 'kilo' ? 'variant_name' : 'product_name'
						let product_name = product[key]
						if(this.data.module.slug != 'laundry' && product.variant_name != null){
							product_name = `[${product.variant_name}] ${product.product_name}`
						}
						if(this.data.module.slug == 'laundry' && i==0){
							data += '(' 
						}
						data += product_name

						if(i+1 != this.data.tx_detail_list.length){
							data += ', '
						}
						if(i+1 == this.data.tx_detail_list.length && this.data.module.slug == 'laundry'){
							data += ')'
						}
					}
					return data
				}else{
					return ''
				}
			}
		},
		mounted(){
		},
		methods:{
			formatDate(date){
				return moment(date).format('hh:mm, DD MMM YYYY');
			},
			formatCurrency(price){
				return formatCurrency(price)
			},
			selectDetail(){
				let type = ''
				if(this.type == 'history'){
					type = this.data.tx_type
				}else{
					type = this.data.module.slug == 'maintenance-request' ? 'SERVICE' : 'ORDER'
				}
				this.$emit("selectDetail",{
					id: this.data.id,
					type: type
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuHistory.vue